import React, { useState, useEffect } from 'react';

import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SidebarAdmin from './sidebaradmin';
import FilterListIcon from '@mui/icons-material/FilterList';


import {
  Link
} from "react-router-dom";
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import { getStudentList, updateStudentStatus ,getLocationList} from "../../actions/admin.actions";
import secureLocalStorage from 'react-secure-storage';
import { useNavigate } from 'react-router-dom';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import {useSelector} from 'react-redux';

const StudentDetails = ({handleTabChange}) => {
   const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [students, setStudents] = useState([]);
  const [searchPlaceholder, setSearchPlaceholder] = useState('Student Id');
  const [searchBy, setSearchBy] = useState('stuid');
  const [searchValue, setSearchValue] = useState('');
   const [searchGenderValue, setSearchGenderValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState(null);
 //const [locations, setLocations] = useState([]);
 const {locations} = useSelector(state => state.userdata);
  const userTypeList = [
    { lable: 'Female', value: 'Female' },
    { lable: 'Male', value: 'Male' }  
  ]
  const perPageChange = (e) => {
    setPerPage(e.target.value);
    setPage(1);
  }

  const changePage = (p) => {
    if (p < 1) p = 1;
    if (p > totalPage) p = totalPage;
    setPage(p);
  }

  const handleSearchInput = (e) => {
    setSearchValue(e.target.value);
  }

  const handleColumnClick = (type) => {
    let placeholder = '';
    switch (type) {
      case 'stuid':
        placeholder = 'Student Id';
        break;
      case 'name':
        placeholder = 'Student Name';
        break;
        case 'grade':
        placeholder = 'Grade';
        break;
      default:
        placeholder = 'Student Id';
        break;
    }
    setSearchValue('');
    setSearchGenderValue('');
    setSearchPlaceholder(placeholder);
    setSearchBy(type);
  }
 const loadStudent = (showLoader) => {
    if (showLoader !== false) {
      setLoading(true);
    }
    getStudentList({ page: page, perPage: perPage, search_by: searchBy, search: searchValue })
      .then((res) => {
        if (res.data.status) {
          setStudents(res.data.data.students);
          setTotalCount(res.data.data.totalCount);
          setTotalPage(res.data.data.totalPage);
        }
        setLoading(false);
        setUpdatingStatus(null);
      }).catch((err) => { });
  }

  const updateStatus = (stuid, status) => {
    setUpdatingStatus(stuid);
    updateStudentStatus({ stuid: stuid, student_status: status })
      .then((res) => {
        if (res.data.status) {
          loadStudent(false);
        }

      }).catch((err) => { });
  }

  const handleEdit = (item) => {
    secureLocalStorage.setItem('editStudentData', item);
    handleTabChange(null, 0, true);
  }

    React.useEffect(() => {
        if (document.body.classList.contains('adminbody_bg')) {
          document.body.classList.remove('body');
        }
        document.body.classList.add('adminbody_bg');
       loadStudent();
    //     getLocationList({ all: 1 }).then((res) => {
    //   setLocations(res.data.data.locations);
    // }).catch((error) => {
    //   console.log(error);
    // });
  }, [page, perPage, searchValue]);

      const handleAutocompleteChange = (type, value) => {
    setSearchValue(value);
  }
  const handleAutocompleteGenderChange = (type, value) => {
    if(value!=null){
    setSearchGenderValue(value);
    setSearchValue(value.value);
  }
    else
    {
      setSearchGenderValue(null);
        setSearchValue('');

    }
  }
   const handleClearFilter = () => {
    setSearchValue('');
     setSearchGenderValue(null);
    setSearchPlaceholder('Student ID');
    setSearchBy('stuid');
  }
  return (
    <Box sx={{ display: 'flex' }}>
    
   
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
    
      <Typography paragraph className=''>
           

              <div className='row'>
            <div className='col-md-12'>
              <div className='club-sec application-sec'>
                <div className='container-fluid '>

                  <div className='form-table-sec table-section-route table-form appl-sec nwd-appl-sec nmd-app' style={{paddingTop:'0px'}}>
                    <div className='row margn-tp-mange-usr' style={{marginTop:'0px'}}>

                    <div className='clr-sec'>
                                      <div className='clearfilr clear-filt'>
                                          <button class="btn btn-login btn-submit bt-forms  btn-clear" type='button' onClick={handleClearFilter}><span className='clear-span'><FilterListIcon /></span>Clear Filter</button>
                                       </div>
                                    </div>
                     
                      <div class="col-sm-3"  >
                        <div class="sorting-e-form sortmng" style={{ marginTop: '0px' }}>
                          <label style={{ width: '100%' }}><span style={{ marginRight: '10px', fontSize: '14px' }}>Show entries</span>
                            <select className='selee-sort' onChange={perPageChange} value={perPage}>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>

                          </label>
                        </div>
                      </div>
                      <div class="col-md-6">

                              {students.length > 0 && (
                          <p class="total-user right-user tot-app mng-app" style={{ marginTop: '0px' }}>Total Student <span className='coun-col'>{totalCount}</span></p>
                           )}


                      </div>
                       {/* <div className='col-md-2'>
                                      <button class="btn btn-login btn-submit bt-forms" type='button' onClick={handleClearFilter}>Clear Filter</button>
                                    </div> */}

                      <div className='col-md-3'>
                      <div className='filtr-sec'>
                          
                           
                        {
                            searchBy == 'location' ?
                              <div className='admn-selct-sec filtr-nwe-sec'>
                                <Autocomplete
                                  id="tags-standard"
                                  value={searchValue || null}
                                  options={locations}
                                  getOptionLabel={(option) => option.locationName}
                                  isOptionEqualToValue={(option, value) => option.id === value.id}
                                  onChange={(event, newValue) => {
                                    handleAutocompleteChange('location', newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="standard"
                                      placeholder="School Name"
                                    />
                                  )}
                                  renderOption={(props, option) => {
                                    return (
                                      <li {...props} key={option.id}>
                                        {option.locationName}
                                      </li>
                                    );
                                  }}
                                  renderTags={(tagValue, getTagProps) => {
                                    return tagValue.map((option, index) => (
                                      <Chip {...getTagProps({ index })} key={option.id} label={option.locationName} />
                                    ))
                                  }}
                                />
                              </div>
                              :
                              <>
                                {
                                  searchBy == 'gender' ?
                                    <div className='admn-selct-sec filtr-nwe-sec'>
                                      <Autocomplete
                                        id="tags-standard"
                                        value={searchGenderValue || null}
                                        options={userTypeList}
                                        getOptionLabel={(option) => option.lable}
                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                        onChange={(event, newValue) => {
                                          handleAutocompleteGenderChange('gender', newValue);
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            variant="standard"
                                            placeholder="Gender"
                                          />
                                        )}
                                        renderOption={(props, option) => {
                                          return (
                                            <li {...props} key={option.id}>
                                              {option.lable}
                                            </li>
                                          );
                                        }}
                                        renderTags={(tagValue, getTagProps) => {
                                          return tagValue.map((option, index) => (
                                            <Chip {...getTagProps({ index })} key={option.id} label={option.lable} />
                                          ))
                                        }}
                                      />
                                    </div>
                                    :
                                    <div className="text-fld-sec appl_status_list adm-usr">
                                      <input type="text" className='inpt-sec' placeholder={searchPlaceholder} onChange={handleSearchInput} value={searchValue} />
                                      <span className='search-sec'><SearchIcon /></span>
                                    </div>
                                }

                              </>
                          }
                        </div>
                        </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12'>
                        <table class="table table-bordered">
                          <thead class="thead-light thead-travel thead-form">
                            <tr>
                            <th className='loc-width'>Sl No </th>
                              <th className='loc-width'  onClick={() => handleColumnClick('stuid')}>Student I'd <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                              <th className='std-id-width'  onClick={() => handleColumnClick('name')}>Student Name <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                             {/* <th className='std-id-width'>DOB <span className='fitr-sec-nw'><FilterListIcon /></span></th>*/}
                              <th className='std-id-width'  onClick={() => handleColumnClick('location')}>School Name <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                              <th className='std-name-width' onClick={() => handleColumnClick('grade')}>Grade <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                              <th className='std-name-width' onClick={() => handleColumnClick('gender')}>Gender <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                              <th className='grade-width'>Status</th>
                              <th className='date-width'>Action</th>
                          
                            </tr>
                          </thead>
                          <tbody className='tbody-light tbody-form'>
                           
 {loading ? (
                              <tr>
                                <td colSpan={8}>
                                  <div className="spinner-border" role="status" style={{ width: "1rem", height: "1rem", marginLeft: "6px" }}></div>
                                </td>
                              </tr>
                            ) : (
                              students.length > 0 ? (
                                students.map((item, index) => (
                                  <tr key={index}>
                                   <td>{((page * perPage) - perPage + 1) + (index)}</td>
                                    <td>{item.stuid}</td>
                                    <td>{item.student_name} {item.last_name}</td>
                                   
                                    <td>{item.school_name}</td>
                                    <td>{item.stu_grade}</td>
                                     <td>{item.gender}</td>
                                    <td>
                                      {
                                        updatingStatus == item.stuid ? (
                                          <div className="spinner-border" role="status" style={{ width: "1rem", height: "1rem", marginLeft: "6px" }}></div>
                                        ) : (
                                          <div class="checkbox">
                                            <input id={`cbx${item.stuid}`} type="checkbox" checked={item.student_status == 'active' ? 'checked' : ''} onChange={(e) => updateStatus(item.stuid, item.student_status == 'inactive' ? 'active' : 'inactive')} className='stauscheck' />
                                            <label class="toggle" htmlFor={`cbx${item.stuid}`}><span></span></label>
                                          </div>
                                        )
                                      }
                                    </td>
                                    <td>
                                      <div className='stst-visi'>
                                        <span className='visib-sec'><EditIcon   onClick={() => handleEdit(item)}/></span>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={8}>No Data Found</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                         {totalPage > 1 && (
                          <div className="pagination-sec" style={{ boxShadow: '#ff98001a 0px 7px 16px 0px', width: "auto", float: "right", border: "1px solid #FF9800", marginTop: "2px", marginRight: "5px", height: "40px" }}>
                            <div style={{ float: "left", padding: "0px 0px", color: "#0B5CAB", fontSize: "14px", width: '100%', position: 'relative', display: 'inline-flex' }}>
                              <div className="" style={{ backgroundColor: '#FF9800', color: '#ffffff' }}>
                                <p style={{ marginBottom: '0px', padding: '9px 10px' }}>Page {page} of {totalPage}</p>
                              </div>
                              <div className="pagin-sec">
                                <i className="fa-solid fa-angle-left" style={{ float: "left", marginTop: "10px", marginLeft: "10px", cursor: "pointer", fontSize: '18px', color: '#727272' }} onClick={() => changePage(page - 1)}></i>
                                <span className="go-sec" style={{ float: "left", fontSize: "15px", marginTop: "10px", marginLeft: "10px", marginRight: '10px', color: "#626262" }}>Go to </span>
                                <input type="number"
                                  value={page}
                                  onChange={(e) => {
                                    !isNaN(parseInt(e.target.value)) && parseInt(e.target.value) > 0 ? changePage(parseInt(e.target.value)) : changePage(1)
                                  }}
                                  style={{ paddingTop: '4px', color: "rgb(0, 23, 55)", margin: "8px 6px 0px 4px", fontSize: "14px", width: "34px", height: '34px', float: "left", textAlign: "center", border: "1px solid #727272", borderRadius: "3px", outline: "none" }}
                                />
                                <i className="fa-solid fa-angle-right" style={{ float: "left", marginTop: "10px", marginRight: '6px', marginLeft: "5px", cursor: "pointer", fontSize: '20px', color: '#727272' }} onClick={() => changePage(page + 1)}></i>
                              </div>
                            </div>
                          </div>
                        )}
                      
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
         

                    
      </Typography>
     
    </Box>
  </Box>
);
}
export default StudentDetails;

